module.exports = __webpack_public_path__ + "img/course6.336bbb58.png";